






























































import Vue from 'vue'
import { Component, VueClass } from '@niknevis/vue-modules'
import { isDef } from '@/modules/shared/helpers/utils/utils'
import { Prop } from 'vue-property-decorator'
import QIcon from 'quasar/src/components/icon/QIcon.js';

type ItemType = {
  label: string
  value: string | number | { component: VueClass<any> | string, props?: object }
  name: string
  icon?: QIcon
  classes?: string
  valueClasses?: string
  rowComponent?: { component: VueClass<any> | string, props?: object }
}

@Component
export default class TesList extends Vue {
  @Prop({ required: true }) items: ItemType[]

  protected get __items() {
    return this.items.map(item => isDef(item.rowComponent) ? item : { ...item, rowComponent: {} })
  }

  private isComponent(value): value is Vue {
    return isDef(value) && value.super === Vue
  }
}
